import ApiClient from '@/api/ApiClient';

const ROUTE = 'tempworker/userprofessionalskill';
const client = new ApiClient(ROUTE);

class UserProfessionalSkillApiTempWorker {

	static add (code: IAddUserProfessionalSkillModel) {
		return client.post<void>('', code);
	}

	static delete (code: string) {
		return client.delete<void>(code);
	}
}

export default UserProfessionalSkillApiTempWorker;
